import CustomLayout from './wrapPageElement';
import './src/styles/_global.scss';

export const wrapPageElement = CustomLayout;
